import { Route } from "components/utils";
import { NotFound } from "pages/notFound";
import { ReservationsList } from "pages/wms/reservationsList/ReservationsList";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

export const Reservations = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/all`} />}
      />
      <Route
        component={ReservationsList}
        exact={true}
        path={`${match.path}/list/:tab`}
        title="Milo - WMS - rezerwacje"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
